import { inject, provide } from 'vue';

export const educationModuleContextKey = Symbol('educationModuleContext');

export function createEducationModuleContext({ host, educationApi }) {
  return {
    educationApi,
    host,
  };
}

export function installEducationModuleContext(app, context) {
  app.provide(educationModuleContextKey, context);

  return app;
}

export function provideEducationModuleContext(context) {
  provide(educationModuleContextKey, context);

  return context;
}

export function useEducationModuleContext() {
  const context = inject(educationModuleContextKey, null);

  if (!context) {
    throw new Error('Education module context is not provided');
  }

  return context;
}
